export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/fog-low-1c4d39bd19d5230fdaccd661a12e5f55.png";